import { CoreAdoptionGrade } from 'common-types'
import AnchorTitles from 'components/arc-core/AnchorTitles'
import CoreText from 'components/arc-core/CoreText'
import ExemplarPack from 'components/arc-core/ExemplarPack'
import FinalProjectOrganizer from 'components/arc-core/FinalProjectOrganizer'
import Framework from 'components/arc-core/Framework'
import GenreCard from 'components/arc-core/GenreCard'
import GraphicOrganizer from 'components/arc-core/GraphicOrganizer'
import InformationalTextSet from 'components/arc-core/InformationalTextSet'
import JeffreyWilhelmText from 'components/arc-core/JeffreyWilhelmText'
import LeveledLibrary from 'components/arc-core/LeveledLibrary'
import PacingGuideSingle from 'components/arc-core/PacingGuideSingle'
import ResearchCard from 'components/arc-core/ResearchCard'
import WritingCards from 'components/arc-core/WritingCards'
import LitLabSection from 'components/core-adoption/LitLabSection'
import ThemeChartLitLabButton from 'components/core-adoption/ThemeChartLitLabButton'
import ThemeChartThemeButton from 'components/core-adoption/ThemeChartThemeButton'
import { Col, Row } from 'components/grid'
import React from 'react'

import LeveledGenreLibrary from '../../arc-core/LeveledGenreLibrary'

const Grade09 = ({ litLab, themes, themeUnit, changeTheme, language, standard }: CoreAdoptionGrade) => {
	return (
		<div id="grade-9" className="w-full">
			<div className="flex">
				<p className="my-auto hidden w-8 font-bold text-slate-800 md:block">9</p>
				<div className="flex w-full">
					{/* Lit Lab Button */}
					<ThemeChartLitLabButton changeTheme={changeTheme} litLab={litLab} themeUnit={themeUnit} />
					{/* Theme Buttons */}
					{themes.map((theme) => {
						if (theme.name === 'Under Review') {
							return (
								<div className="flex w-1/4 cursor-default items-center justify-center border p-3" key={theme.id}>
									<img src="/images/utils/theme-under-review.png" alt="theme under review" style={{ maxHeight: 50 }} />
								</div>
							)
						}
						return <ThemeChartThemeButton key={theme.id} changeTheme={changeTheme} name={theme.name} id={theme.id} logo={theme.logo.file.url} themeUnit={themeUnit} />
					})}
				</div>
			</div>
			{themeUnit === litLab.id && <LitLabSection litLab={litLab} grade={9} gradeRange="hs" hookBooks={litLab.hookBookLibrary} language={language} standard={standard} />}
			{themes.map((theme, index) => {
				if (themeUnit === theme.id) {
					return (
						<div key={theme.id}>
							<Row className="mt-6 justify-center">
								<Col width="w-1/2 md:w-1/4" className="material-column">
									<Framework
										image={standard === 'TEKS' ? theme?.frameworkCoverTeks?.gatsbyImageData : theme?.frameworkCover?.gatsbyImageData}
										fullFramework={standard === 'TEKS' ? theme?.fullFrameworkTeks?.file?.url : theme?.fullFramework?.file?.url}
										updatedAt={standard === 'TEKS' ? theme?.fullFrameworkTeks?.updatedAt : theme?.fullFramework?.updatedAt}
									/>
								</Col>
								<Col width="w-1/2 md:w-1/4" className="material-column">
									<PacingGuideSingle image={standard === 'TEKS' ? theme.pacingGuideTeks : theme.pacingGuide} shadow />
								</Col>
								{theme.finalProjectOrganizer && (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<FinalProjectOrganizer images={theme.finalProjectOrganizer} />
									</Col>
								)}
								{theme.graphicOrganizer && (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<GraphicOrganizer images={theme.graphicOrganizer} />
									</Col>
								)}
								{theme.researchCard && (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										{index === 1 ? (
											<GenreCard updatedAt={theme.researchCard.updatedAt} image={theme.researchCard.gatsbyImageData} />
										) : (
											<ResearchCard updatedAt={theme.researchCard.updatedAt} image={theme.researchCard.gatsbyImageData} />
										)}
									</Col>
								)}
								{theme.coreTextTeks && standard === 'TEKS' ? (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<CoreText image={theme.coreTextTeks.gatsbyImageData} />
									</Col>
								) : null}
								{!theme.coreTextTeks && theme.coreText && standard === 'TEKS' ? (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<CoreText image={theme.coreText.gatsbyImageData} />
									</Col>
								) : null}
								{theme.coreText && standard === 'CCSS' ? (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<CoreText image={theme.coreText.gatsbyImageData} />
									</Col>
								) : null}
								{theme.exemplarPack && (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<ExemplarPack image={theme.exemplarPack.gatsbyImageData} />
									</Col>
								)}
								{index !== 0 && (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<JeffreyWilhelmText unit={index + 2} />
									</Col>
								)}
								{(index === 0 || index === 2) && (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<WritingCards unit={index + 2} language={language} />
									</Col>
								)}
								{theme.anchorTitles && (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<AnchorTitles image={theme.anchorTitles.gatsbyImageData} />
									</Col>
								)}
								{theme.informationalTextSet && (
									<Col width="w-1/2 md:w-1/4" className="material-column">
										<InformationalTextSet image={theme.informationalTextSet.gatsbyImageData} />
									</Col>
								)}
								{theme.leveledLibraryTeks && standard === 'TEKS' ? (
									<Col width="w-full" className="material-column">
										{index === 1 ? <LeveledGenreLibrary baskets={theme.leveledLibraryTeks} /> : <LeveledLibrary baskets={theme.leveledLibraryTeks} />}
									</Col>
								) : null}
								{!theme.leveledLibraryTeks && theme.leveledLibrary && standard === 'TEKS' ? (
									<Col width="w-full" className="material-column">
										{index === 1 ? <LeveledGenreLibrary baskets={theme.leveledLibrary} /> : <LeveledLibrary baskets={theme.leveledLibrary} />}
									</Col>
								) : null}
								{theme.leveledLibrary && standard === 'CCSS' ? (
									<Col width="w-full" className="material-column">
										{index === 1 ? <LeveledGenreLibrary baskets={theme.leveledLibrary} /> : <LeveledLibrary baskets={theme.leveledLibrary} />}
									</Col>
								) : null}
							</Row>
						</div>
					)
				}
			})}
		</div>
	)
}

export default Grade09
